module.exports = __webpack_public_path__ + "static/media/jcb.d80f28eb.svg";